<template>
  <div class="maps">
    
    <b-navbar type="dark" variant="dark" fixed="top" toggleable="sm">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand to="/home" active> 🏢 </b-navbar-brand>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item active><b-icon-map></b-icon-map> Map </b-nav-item>
          <b-nav-item @click="$router.push('/data-warehouse')"><b-icon-file-earmark></b-icon-file-earmark> Data Warehouse </b-nav-item>
          <b-nav-item @click="$router.push('/reports')"><b-icon-newspaper></b-icon-newspaper> Reports </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item @click="logout()">
            <b-icon-box-arrow-left></b-icon-box-arrow-left>
            Logout {{username}}
            <b-avatar class="mr-3" size="1.3em">
              <v-gravatar :size="100" default-img="retro" :email="username" />
            </b-avatar>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <main role="main" class="ml-sm-auto px-4">
      <!-- ref will be available after the component is mounted to it has to be outside of v-if! -->
      
      <!-- <div class="map-container" ref="mapboxglMap"></div> -->
      <div v-if="!density_data">
        <p class="mt-2">Loading...</p>
        <div class="pb-4">
          <b-overlay show rounded="sm"></b-overlay>
        </div>
      </div>

      <!-- MAPS -->

      <div v-else>
        <b-overlay :show="loadingData" rounded="sm">
        <!-- TOP BARS -->
        <b-row class = "mb-2">
          <b-col>
            <!-- Campus button -->
            <div class = "map-overlay-nav-campus-btn mr-2">
              <b-btn class="mr-2 sm" size="sm" :variant="upcCenter === mapCenter ? 'danger' : 'outline-danger'" @click="flyTo(upcCenter)">UPC</b-btn>
              <b-btn class="mr-2 sm" size="sm" :variant="nupCenter === mapCenter ? 'danger' : 'outline-danger'" @click="flyTo(nupCenter)">NUP</b-btn>
              <b-btn class="mr-2 sm" size="sm" :variant="hscCenter === mapCenter ? 'danger' : 'outline-danger'" @click="flyTo(hscCenter)">HSC</b-btn>
            </div>
            <!-- Search Bar -->
            <div class = "map-overlay-nav-search-bar">
              <v-select style="display:inline-block;width:400px"
                        :options="search_options" 
                        label = "name"
                        :reduce="building => building.id" placeholder = "Search for buildings"
                        v-model="selected"></v-select>
              <b-btn :disabled="selected == null" class="ml-2 mb-1" size="sm" variant= "danger" @click="flyToBuilding()">Go To</b-btn>
            </div>
            <!-- Date Range Selection -->
            <div class = "map-overlay-nav-date-range ml-2">
              <b-form inline>
                  <b> Data from: </b>
                  <b-form-datepicker value-as-date locale='en-US' class="ml-2 mr-2" v-model="start_date" :hide-header="true"
                                    selected-variant = 'danger' calendar-width = "200px"
                                   :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                                  ></b-form-datepicker>
                  <span>~</span>
                  <b-form-datepicker value-as-date locale='en-US' class="ml-2 mr-2" v-model="end_date" :hide-header="true"
                                   selected-variant = 'danger' calendar-width = "200px"
                                   :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                                  ></b-form-datepicker>
                  <b-button class = "ml-2" variant = "danger" size = "sm" @click = "changeDateRange()">Update Date Range</b-button>
                </b-form>
            </div>

            <!-- Building Preference Selection -->
            <div class = "map-overlay-nav-date-range ml-2">
              <b-button v-b-modal.modal-2 class = "ml-2" variant = "danger" size = "sm">Building Preference</b-button>
              <b-modal id="modal-2" title="" ok-variant  = "danger" @ok = "changeDateRange()" no-close-on-backdrop>
                <!-- current building preference -->
                <b-row>
                  <b-col>
                    <b> Currently Building Preference:</b>
                    <div class = "mt-2" v-if= "user_buildings.length != 0"> 
                      <b-badge class="ml-2" v-for="(building, index) in user_buildings" :key="index" 
                        :variant = "['UPC','NUP', 'HSC'].indexOf(building) == -1? 'danger' : 'info'">
                        {{building}}
                        <b-icon icon = "x" font-scale="1.3" class="rounded border border-light" :variant="buttonHover == index? 'danger': 'light'"
                        :class="{'bg-transparent':buttonHover != index, 'bg-light':buttonHover == index }" 
                        @click = "user_buildings.splice(index, 1); buttonHover = null;" @mouseover="buttonHover = index" @mouseout = "buttonHover = null"></b-icon>
                      </b-badge>
                    </div>
                    <div class = "mt-2" v-else> <b-alert show variant="warning"> Current No Buildings in Preference, please add buildings. </b-alert></div>
                  </b-col>
                </b-row>
                <!-- building preference add tools -->
                <b-row class = "mt-2">
                  <b-col>
                    <b> Search and Add New Buildings:</b>
                    <v-select class = "mt-2" style="display:inline-block;width:400px"
                        :options="all_buildings_name" 
                        label = "description"
                        :reduce="building => building.aname" placeholder = "Search for buildings add to preference"
                        v-model="building_add_to_preference"></v-select>
                    <b-btn :disabled="building_add_to_preference == null" class="ml-2 mb-1" size="sm" variant= "danger" @click="AddBuildingToPreference()">Add</b-btn>
                  </b-col>
                </b-row>
              </b-modal>
            </div>
          </b-col>
        </b-row>

        <!-- MAPS AND GRAPH -->
        <b-row>
          <b-col cols = "7">
            <!-- map -->
             <!-- campus navigation button -->
            <b-card>
              <div class="map-container" ref="mapboxglMap"></div>
              <!-- map overlay -->
              <div class="map-overlay">
                  <div class="map-overlay-inner">
                    <div class="mt-1 text-left">
                      <b>Threshold: {{formatThres(thres_value)}}</b>
                    </div>
                    <div>
                      <input id="myinput" type="range" min="0" :max="this.max_density_count" ref="myinput" step="1" v-model="thres_value" @input="updateThreshold">
                      <span><b>0</b></span><span class = "float-right"><b>{{max_density_count}}</b></span>
                    </div>
                    <div class="mt-1">
                      <div style="display: inline-block">
                        <div style="border: 3px solid green;width: 12px; height: 12px;display: inline-block"></div>
                        <div class = "ml-1" style="display: inline-block">Selected Building</div>
                      </div>
                      <div class = "ml-1" style="display: inline-block">
                        <div style="border: 3px solid red;width: 12px; height: 12px;display: inline-block"></div>
                        <div class = "ml-1" style="display: inline-block">Top10 Building (counts)</div>
                      </div>
                    </div>

                    <!-- <b-link size="sm" block class="mw-100 mt-0 mb-2" v-b-modal.logsmodal>data logs</b-link> -->
                    <!-- <b-modal scrollable size="xl" class="logs-modal" id="logsmodal" title="Data logs" ok-only>
                      <div v-html="dataLogs"></div></b-modal> -->
                  </div>
              </div>
            </b-card>
          </b-col>

          <!-- charts -->
          <b-col cols = "5">
            <b-card no-body>
              <b-tabs card>
                <b-tab title="Top 10 Building Density" active>
                  <div v-if="density_data&&density_data.data.length > 0">
                    <highcharts :options="top10_buildingChartOptions" style="width:100%;" ref = "top10_building_chart"></highcharts>
                    <b-form-input class = "" type="range" min="0" :max="all_day_value.length-1" step="1" v-model="time_value" @input="updateTimeSlider()"></b-form-input>
                    <div class="mt-2 text-left">
                      <b>Time: {{ formatDateTime(this.time_value)}}</b>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Selected Building Density">
                  <div v-if = "building_selected.length != 0">
                    <highcharts :options="selected_buildingChartOptions" style="width:100%;" ref = "selected_building_chart"></highcharts>
                    <b-form-input class = "" type="range" min="0" :max="all_day_value.length-1" step="1" v-model="time_value" @input="updateTimeSlider()"></b-form-input>
                    <div class="mt-2 text-left">
                      <b>Time: {{ formatDateTime(this.time_value)}}</b>
                    </div>
                  </div>
                  <div v-else>
                    No building selected, please selected a building on the map.
                  </div>
                </b-tab>
              </b-tabs>
            </b-card>
          </b-col>

        </b-row>
        
        <!-- Building Toggles -->
        <b-btn class = "mt-3 text-left" style="width:100%;background-color:#a50000">
               Building Details
        </b-btn>

        <!-- BUILDINGS -->
        <!-- building -->
        <b-collapse id="building_collapse" visible class="building-container mt-3">
          <!-- buttons for controling selected buildings -->
          <b-row>
          <b-col class="mb-1">
            <b>Selected Building:</b>
            <span v-if= "building_selected.length != 0"> 
              <b-badge class="ml-2"  variant = "success" v-for="(building, index) in building_selected" :key="building.id">
                  {{building.name}}
                  <b-icon icon = "x" font-scale="1.3" class="rounded border border-light" :variant="buttonHover == index? 'success': 'light'"
                  :class="{'bg-transparent':buttonHover != index, 'bg-light':buttonHover == index }" :id = "'CC' + building.id" 
                  @click = "deleteBuildingBadge" @mouseover="buttonHover = index" @mouseout = "buttonHover = null"></b-icon>
              </b-badge>
            </span>
            <span v-else> No Building Selected </span>
          </b-col>
        </b-row>

          <!-- building tabs -->
          <b-row v-if = "building_selected.length != 0">
            <b-col cols = "12">
            <b-tabs card v-model="tab_index" v-on:changed="tabs_change">
              <b-tab no-body v-for="element in building_selected" :key= "element.id" :title = "element.name" :id = "'AA' + element.id" v-on:click = "tab_activate">
                  <!-- <b-link class="float-right" @click="setBuilding(null)"><b-icon-x-circle></b-icon-x-circle></b-link> -->
              </b-tab>
            </b-tabs>
            </b-col>
          </b-row>
                
          <!-- Floors details -->
          <b-row v-if = "this.building" class = "mt-3 pl-2">
            <!-- floorMap -->
            <b-col cols="7">
              <div class = "mb-3 mt-3">
                <b-btn v-for="(fl, index) in building.floors" :key="index" :variant="floor === fl ? 'warning' : 'info'" size="sm" class="sm mr-2" style="border-radius: 4px; color: white; width: fit-content;" @click="setFloor(fl)">{{fl.name}}</b-btn>
              </div>
              <div class = "mt-2 mb-2">
                  <b> FloorMap: {{floor.name}} </b>
              </div>
              <div id = 'floormap' style="height:500px;" class = "border border-dark">
                <svg ref="floorPlan"
                  width="100%" height="100%" 
                  :viewBox = "'0 0 ' + floor.width + ' ' + floor.height" 
                  style="background-color: #FFFFFF;"
                  preserveAspectRatio = "xMidYMid meet">
                  <g v-if="floor">
                    <g>
                      <image v-if="floor.image" 
                      :alt="VUE_APP_SITE_DATA + floor.image" 
                      :href="VUE_APP_SITE_DATA + floor.image"
                      :width = "floor.width"
                      :height= "floor.height"
                      preserveAspectRatio = "xMidYMid meet" />
                    </g>
                    <g>
                      <line v-for="(ap, index) in floor.ap" :key="'ap-density' + index"
                        :x1="ap.x" :y1="ap.y"
                        :x2="ap.x" :y2="ap.y"
                        stroke-linecap="round"
                        :stroke-width="ap.data[time_value][1]*2"
                        vector-effect = "non-scaling-stroke"
                        stroke-opacity = "0.7"
                        fill = "#86bced"
                        stroke = "#86bced"
                      />
                      <line :id="ap.name" v-for="(ap, index) in floor.ap" :key="'ap' + index" 
                        @mouseover="showTooltip(ap.name, ap.data[time_value][1], $event)" 
                        @mouseout="hideTooltip"
                        :x1="ap.x" :y1="ap.y"
                        :x2="ap.x" :y2="ap.y"
                        :title="ap.name + ': ' + ap.data[time_value][1] + ' connections'"
                        stroke-width = "6"
                        stroke-opacity = "0.8"
                        stroke-linecap="round"
                        vector-effect = "non-scaling-stroke"
                        stroke = "red"
                        fill = "red"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </b-col>
            <!-- AP charts -->
            <b-col cols = "5">
              <b-tabs>
                <b-tab title = "Floor Density">
                  <div class="mt-4 text-left">
                    <b>Time: {{ formatDateTime()}}</b>
                  </div>
                  <b-form-input type="range" min="0" :max="all_day_value.length-1" step="1" 
                    v-model="time_value" @input="updateTimeSlider()"></b-form-input>
                  <highcharts :options="floorChartOptions" style="width:100%;" 
                    ref = "floor_density_chart"></highcharts>
                </b-tab>
                <b-tab title = "Access Point Density">
                  <div class = "mt-4">
                    <b>Access Point Density: {{floor.name}}</b> 
                  </div>
                  <div v-if = "this.floor">
                    <!-- time slider -->
                    <div class="mt-2 text-left">
                      <b>Time: {{formatDateTime()}}</b>
                    </div>
                    <b-form-input type="range" min="0" :max="all_day_value.length-1" step="1" 
                      v-model="time_value" @input="updateTimeSlider()"></b-form-input>
                    <!-- charts -->
                    <highcharts :options="apChartOptions" style="width:100%;" 
                      ref = "ap_density_chart"></highcharts>
                  </div>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
          <b-card v-if = "!building">
            <b-card-text>
              <b-alert show variant="warning"> No building selected, please select a building in the map.</b-alert>
            </b-card-text>
          </b-card>
        </b-collapse>
        <!-- customized overlay -->
        <template #overlay>
          <div class="text-center">
          <b-icon icon="arrow-clockwise" animation="spin-pulse" font-scale="2.5"></b-icon>            
          <h5 class = "mt-3"><b>Please wait for data loading...</b></h5>
        </div>
      </template>
      </b-overlay>
      </div>
      <!-- tooltips -->
      <div ref="mypopup" style="position:absolute; z-index:100;width:170px;padding: 2px;font-size: 8pt;display:none;
                              background-color: white;border-color:black; border-style: solid;border-width: 1px;border-radius:2px;" :style="{top: top_dis+'px', left: left_dis+'px'}">
      <b>{{ap_show_name}}: {{ap_show_connections}} connections.</b>
    </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import * as moment from "moment/moment";

import * as d3 from "d3";
//import vegaEmbed from "vega-embed";

import turf from "turf";

import Vue from 'vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect)

/////////////////////
// NOTES:
// Building with no id and floors: TRF, BDF - TRF 14 building in top-left corner of UPC, BDF - 7 building around baseball court of UPC
// Building with maximum floors: WTO 16 floors, UPC
// #Building 212, #ap 5899

export default {
  name: "Maps",
  components: {},
  data: function () {

    let end_date =  new Date(2020, 8, 7);
    let start_date = new Date(end_date);
    start_date.setDate(start_date.getDate() - 14);
    
    return {
      /////////////////////
      //map
      mapCenter: null,
      upcCenter: [-118.28292, 34.0227],
      nupCenter: [-118.28379, 34.0259],
      hscCenter: [ -118.20267677307129,34.063396762532626],
      map: null,
      footprint:null,

      /////////////////////
      //density data
      thres_value:0,
      thres_scale:null,
      max_density_count:0,
      all_day_value: [],
      density_data:null,
      building_name: null,
      building_id:null,
      floor_index:'1.0',

      /////////////////////
      //Time Slider
      time_value:0,

      ////////////////////
      // Building selection stack
      building_selected: [],
      tab_index:0,

      ////////////////////
      //line charts
      top10_buildingChartOptions:null,
      selected_buildingChartOptions:null,
      apChartOptions:null,
      floorChartOptions:null,
      barChartOptions:null,

      /////////////////////
      //building floors
      show_building:false,
      building: null,
      floor: null,
      VUE_APP_SITE_DATA: process.env.VUE_APP_SITE_DATA,
      devexp: false,
      width: "100%",
      height: 200,
      size: 800,
      dataLogs: '',

      //////////////////////
      // search buildings
      search_options: [],
      selected:null,

      /////////////////////
      // date range and user building preference
      all_available_dates:[],
      end_date: end_date,
      start_date: start_date,
      all_buildings_name:[{aname: 'UPC', description:"UPC (All Buildings on UPC campus)", id:"upc"}, 
                     {aname: 'NUP', description:"NUP (All Buildings on NUP campus)", id:'nup'}, 
                     {aname: 'HSC', description:"HSC (All Buildings on HSC campus)", id:'hsc'}], 
      building_add_to_preference:null,
      user_buildings: ["UPC", "NUP", "HSC"],
      
      /////////////////////
      // ap tooltips
      ap_show_name:'',
      ap_show_connections:0,
      top_dis : 0,
      left_dis : 0,
      
      //overlay
      loadingData:false,
      
      //hoverbuttionIndex
      buttonHover:null
    };
  },
  methods: {
    logout() {
      this.$router.push("/logout");
    },

    ////////////////////////////////////////////////////////////////////
    //change date range
    changeDateRange(){

      //set overlay
      this.loadingData = true;
      
      //reset intial values
      this.building_name = null;
      this.building_id = null;
      this.floor_index = '1.0';
      this.time_value = 0;
      this.building_selected = [];
      this.tab_index = 0;
      this.selected_buildingChartOptions = null;
      this.apChartOptions = null;
      this.barChartOptions = null;
      this.show_building = false;
      this.building = null;
      this.floor = null;
      this.selected = null;
      this.search_options = [];
      this.building_add_to_preference = null;
      
      //set dates initialization
      this.mapCenter = this.upcCenter; //start at UPC

      //generate parameters for time range
      let startTimeStamp = this.start_date.getTime()/1000;
      let endTimeStamp = this.end_date.getTime()/1000;
      // console.log("start_time:", this.start_date, startTimeStamp, "end_time:", this.end_date, endTimeStamp);
      
      //generate timestamp array
      this.all_day_value = [];
      let vm = this;
      for(let ts = startTimeStamp; ts <= (endTimeStamp + 3600*24); ts+= 3600){
        this.all_day_value.push(ts*1000);
      }

      // console.log(this.all_day_value);
      //request for footprint containing hourly data based on buildings and time range preference
      axios.post(
        process.env.VUE_APP_API_URL + '/getFootprintWithHourlyData', 
          {start_time: startTimeStamp, end_time: endTimeStamp, building_list:JSON.stringify(this.user_buildings)},
          { headers: { authorization: localStorage.getItem('density.token') }}
      ).then(response =>{

        //////////////////////////////////////////////////////////////////////////
        // density data
        console.log(response.data);
        //////////////////////////////////////////////////////////////////////////
        // density data, footprint, search_options
        vm.density_data = response.data.density_data;
        vm.footprint = response.data.footprint;
        vm.search_options = response.data.search_options;
        vm.top_building_density = response.data.top_building_density;
        
        // //store density data
        // //vm.$store.commit("density_data", vm.density_data);


        // //get maximum of building count by loop over the footprint
        vm.max_density_count = vm.density_data.max_count;   
        vm.max_density_count = (parseInt(vm.max_density_count/100) + 1)*100;
        vm.thres_scale = d3.scalePow().exponent(0.4).domain([0, vm.max_density_count]).range([0, vm.max_density_count]);

        //top10
        this.top10_buildingChartOptions = this.plotCharts(vm.top_building_density);

        // //update map
        this.map.getSource("footprints").setData(vm.footprint);

        // //set intial feature state
        this.initMapFeatureStates();

        // console.log('finished-5');
        this.loadingData = false;

      });

    },
    ///////////////////////////////////////////////////////////////////
    //building tab control
    tabs_change(){
      
      //no building selected, set to initial
      if(this.building_selected.length == 0){
        this.tab_index = 0;
        this.building = null;
      }

      //only one tabs
      if(this.building_selected.length == 1){
        this.tab_index = 0;
        this.building = this.building_selected[this.building_selected.length-1];  
        this.setBuilding(this.building);
      }

      //when close the last tab in stack, set it to previous
      if(this.tab_index == this.building_selected.length - 1){
        this.tab_index = this.building_selected.length - 1;
        //set building to show in the page when first tab activate
        this.building = this.building_selected[this.building_selected.length-1];  
        this.setBuilding(this.building);
      }

    },
    tab_activate(event){
      // console.log(event.target);
      let building_id = event.target.id.substring(2, event.target.id.length - 18);
      // console.log(building_id);
      for(let element of this.building_selected){
          if(building_id == element.id){
              this.building = element;
              this.setBuilding(this.building);
          }
      }
    },
    
    ///////////////////////////////////////////////////////////////////
    //map
    flyTo(center){
        this.mapCenter = center;
        this.map.setZoom(process.env.VUE_APP_ZOOM_LEVEL);
        this.map.flyTo({center});
    },

    flyToBuilding(){

      if(this.selected != null){

        console.log("flyto", this.selected);
        
        for(let building of this.footprint.features){
          
          if(building.properties.id == this.selected){
            let center = turf.centroid(building).geometry.coordinates;
            this.map.flyTo({center:center, zoom: parseInt(process.env.VUE_APP_ZOOM_LEVEL)+2});
          }

        }
      }


    },

    /////////////////////////////////////////////////////////////////////
    // building preference
    AddBuildingToPreference(){
      
      let building_in_preference = false;

      for(let building of this.user_buildings){
        if(this.building_add_to_preference == building){
          building_in_preference = true;
        }
      }

      if(building_in_preference == false){
        if(this.building_add_to_preference == "UPC" || this.building_add_to_preference == "NUP" || this.building_add_to_preference == "HSC"){
          this.user_buildings.unshift(this.building_add_to_preference);
        }else{
          this.user_buildings.push(this.building_add_to_preference);
        }
      }

    },

    ////////////////////////////////////////////////////////////////////
    // threshold
    updateThreshold: function(event){

      let min  = event.target.min
      let max = event.target.max
      let value = this.thres_value

      event.target.style.background = 
      `linear-gradient(to right, grey 0%, grey ${(value-min)/(max-min)*100}%, #fca107 ${(value-0)/(max-min)*100}%, #e50000 100%)`

      this.updateBuildingDensity()

    }, 

    ///////////////////////////////////////////////////////////////////
    //time slider
    updateTimeSlider: function(){
      
      //update map
      this.updateBuildingDensity();

      //update top10 charts
      if(this.density_data && this.density_data.data.length > 0){

        let top10_chart = this.$refs.top10_building_chart;
        if(top10_chart){
          this.updateVerticalLine(top10_chart.chart);
        }else{
          console.log("Can't find top10 chart in $ref")
        }

      }

      //update selected charts
      if(this.building_selected && this.building_selected.length > 0){

        let selected_chart = this.$refs.selected_building_chart;
        if(selected_chart){
          this.updateVerticalLine(selected_chart.chart);
        }else{
          console.log("Can't find selected chart in $ref")
        }

      }     

      //update floor charts
      if(this.building && this.building.floors){

        let floor_chart = this.$refs.floor_density_chart;
        if(floor_chart){
          this.updateVerticalLine(floor_chart.chart);
        }else{
          console.log("Can't find floor chart in $ref")
        }

      }

      //update ap charts
      if(this.floor && this.floor.ap){

        let ap_chart = this.$refs.ap_density_chart;
        if(ap_chart){
          this.updateVerticalLine(ap_chart.chart);
        }else{
          console.log("Can't find ap chart in $ref")
        }

      }  
    },

    ////////////////////////////////////////////////////////////////////
    // initial feature state of map
    initMapFeatureStates: function(){
      
      //set red border for top10 building
      for(let building of this.density_data.data.slice(0,10)){
        this.map.setFeatureState({id: building.id, source: "footprints" }, {top10_border:true});
      }

      //set border, count and disabled feature state
      for(let building of this.density_data.data) {

        //get count of current time value
        let counts = 0;

        if(building.data.length > 0){
          if(this.time_value < building.data.length){
            counts = building.data[this.time_value][1];
          }
        }

        //count density feature state
        const state = {count: counts};

        this.map.setFeatureState({ id: building.id, source: "footprints" }, state);
        this.map.setFeatureState({ id: building.id, source: "footprints" }, {border:false});

        //disabled feature state
        const state_disabled = {disabled: counts < this.thres_scale.invert(this.thres_value)? true: false};
        this.map.setFeatureState({ id: building.id, source: "footprints" }, state_disabled);

      }

    },

    ///////////////////////////////////////////////////////////////////
    //update density, border, disabled of all building
    updateBuildingDensity: function() {

      for(let [index, building] of this.footprint.features.entries()) {

        let counts = 0;
        let building_density = this.density_data.data[index];

        if(building_density.data.length > 0){

          if(this.time_value < building_density.data.length){

            counts = building_density.data[this.time_value][1];

          }

        }

        //count density feature state
        const state = {count: counts};

        this.map.setFeatureState({ id: building.properties.id, source: "footprints" }, state);
        
        //disabled feature state
        const state_disabled = {disabled: counts < this.thres_scale.invert(this.thres_value)? true: false};
        this.map.setFeatureState({ id: building.properties.id, source: "footprints" }, state_disabled);

      }
    },

    //////////////////////////////////////////////////////////////////
    //set floor plan
    setFloor(fl) {
      this.floor_index = fl.floor;
      this.floor = fl;
      if(this.floor && this.floor.ap){
        this.apChartOptions = this.plotCharts(this.floor.ap);
      }
      // console.log(this.floor);
    },

    //////////////////////////////////////////////////////////////////
    //sort floor by name
    sortFloorsByName(floors) {
      //sort floors n → 0
      floors.sort((b, a) => {  
        let anum = a.name.split(' ').pop();
        anum = isNaN(anum) ? 0 : +anum;

        let bnum = b.name.split(' ').pop();
        bnum = isNaN(bnum) ? 0 : +bnum;
        
        return ((anum > bnum) ? -1 : 1); 
      });

      floors = [
        floors.find(item => item === 'Basement'),
        ...floors.filter(item => item !== 'Basement'),
      ];

      floors = [
        floors.find(item => item === 'Sub-basement'),
        ...floors.filter(item => item !== 'Sub-basement'),
      ];
    },

    //////////////////////////////////////////////////////////////////
    //sort floor by floor
    sortByFloorsFloor(floors) {
      //sort floors n → 0
      floors.sort((a, b) => {
        let _a = a.floor.split('.');
        let _b = b.floor.split('.');
        _a[0] > _b[0] ? -1 : 
          _a[1] > _b[1] ? 1 : -1;
      });

      floors = [
        floors.find(item => item === 'Basement'),
        ...floors.filter(item => item !== 'Basement'),
      ];

      floors = [
        floors.find(item => item === 'Sub-basement'),
        ...floors.filter(item => item !== 'Sub-basement'),
      ];
    },

    //////////////////////////////////////////////////////////////////
    //set building
    setBuilding(building) {
      this.building = building;
      if (building) {
        if (building.floors) {
          // console.log("building floor", building.floors);
          this.sortFloorsByName(building.floors);
          //set default to 1st floor; should be the one with most density
          this.floor_index = "1.0";
          let found = building.floors.find(el => {return el.floor === this.floor_index});
          this.floor = found ? found : 
            building.floors.length >=1 ? building.floors[0] : null;
          this.setFloor(this.floor);

          // console.log(this.floor);

          //if building has floors draw floor plot
          this.floorChartOptions = this.plotCharts(this.building.floors);

        } else {
          this.floor = null;
          this.floorChartOptions = null;
        }
      }else{
        this.map.setFeatureState({ source: "footprints", id: this.building_id }, { border: false });
        this.floor_index = '1.0';
        this.floorChartOptions = null;
      }
    },
    ///////////////////////////////////////////////////////////////////
    // Ap tooltips
    showTooltip(ap_name, ap_count, event){
      
      var ap = event.target.getBoundingClientRect();
      this.ap_show_name = ap_name;
      this.ap_show_connections = ap_count;
      var mypopup = this.$refs.mypopup;
      this.left_dis = (ap.right + 20)
      this.top_dis = (window.scrollY + ap.top - 20)
      mypopup.style.display = "block";
    },

    hideTooltip(){
      
      var mypopup = this.$refs.mypopup;
      mypopup.style.display = "none";

    },
    
    //////////////////////////////////////////////////////////////////
    //verify data
    verifyData() {
      //XXX: best done with bflint
      this.dataLogs = '';
      this.density_data.features.forEach(feature => {
          if (!feature.properties.floors) {
            this.dataLogs += '<div>🚨 ' + feature.properties.aname + ' no floors: feature.properties=<code>' + JSON.stringify(feature.properties) + '</code></div>';
          } else {
            feature.properties.floors.forEach(fl => {
              if (!fl.ap) {
                this.dataLogs += '<div>🧨 📡 ' + feature.properties.aname + ' no aps in floor=<code>' + JSON.stringify(fl) + '</code></div>';
              }
            });
          }
      });
    },

    /////////////////////////////////////////////////////////////
    // Related to selected building stack operation
    // add building to stack by building id, return operation success or not
    addBuildingToStack(building_data){
      
      if(this.building_selected.length == 0){
        this.building_selected.push(building_data);
      }else{
        let find = false;
        for(let building of this.building_selected){
          if(building.id == building_data.id){
            find = true;
          }
        }
        if(find == false){
          this.building_selected.push(building_data);
        }
      }

    },

    //remove element from selected stack by id, return element if not found return null
    removeBuildingFromStack(building_id){

      if(this.building_selected.length == 0){
        return null;
      }else{
      
        let remove_index = -1;
        for(let index in this.building_selected){
          if(this.building_selected[index].id == building_id){
            remove_index = index;
          }
        }

        if(remove_index != -1){
          
          let remove_element = this.building_selected.splice(remove_index, 1);
          return remove_element[0];
          
        }else{
          return null;
        }

      }

    },

    ////////////////////////////////////////////////////////////////////////
    // click bulidng badge to unselect building
    deleteBuildingBadge(event){

        //console.log(event.target.id);
        this.buttonHover = null;

        let building_id = event.target.id.slice(2,);

        //remove building from stack
        this.removeBuildingFromStack(building_id);

        //set building detials
        //no building selected, set to initial
        this.tabs_change();

        //set map border states
        this.map.setFeatureState({ source: "footprints", id: building_id }, { border: false});

    },

    /////////////////////////////////////////////////////////////////////
    hoverInBuildingBadge(event){

      event.target.class = "bg-danger";
    },
    hoverOutBuildingBadge(event){

      event.target.class = "bg-success";
    },
    /////////////////////////////////////////////////////////////////////
    //update vertical line of a charts based on time
    updateVerticalLine(chart){
      
      chart.xAxis[0].removePlotLine('slider-line');
      chart.xAxis[0].addPlotLine({
        color: '#FF0000',
        width: 1.5,
        value: this.all_day_value[this.time_value],
        id:'slider-line',
        zIndex:10
      });

    },

    ///////////////////////////
    //Plot Line Charts
    plotCharts(chart_data){

      let data = chart_data;
      let result = null;

      if(data != null && data.length > 0){
    
        result = {
          chart: {
            type: 'line'
          },
          title: {
            text: ''
          },
          legend:{
            align:"center",
            verticalAlign:"top"
          },
          xAxis : {
            type: 'datetime',
            crosshair:true,
            plotLines: [{
              color: '#FF0000',
              width: 1.5,
              value: this.all_day_value[this.time_value],
              id:'slider-line',
              zIndex:10
            }]
          },
          yAxis: {
            title: {
              text: ''
            }
          },
          series: data
        };
      }

      return result;
    },

    ////////////////////////////////////////////////////////////
    // Plot bar charts
    plotBarCharts(chart_data){

      let data = chart_data;
      let result = null;

      if(data != null && data.length > 0){
    
        result = {
          chart: {
            type: 'line'
          },
          title: {
            text: ''
          },
          legend:{
            align:"center",
            verticalAlign:"top"
          },
          xAxis : {
            type: 'datetime',
            crosshair:true,
            plotLines: [{
              color: '#FF0000',
              width: 1.5,
              value: this.all_day_value[this.time_value],
              id:'slider-line',
              zIndex:10
            }]
          },
          yAxis: {
            title: {
              text: ''
            }
          },
          series: data
        };
      }

      return result;
    },

    ////////////////////////////////////////////////////////////
    // timestamp to unix timestamp
    formatDateTime(){

      return moment(this.all_day_value[this.time_value]).format("h:00 a,  Do MMM, ddd, YYYY");

    },
    formatDate(date){
      return moment(date).format("ddd, MMM Do YYYY")
    },

    formatThres(thres_value){
      return this.thres_scale == null? 0 : parseInt(this.thres_scale.invert(thres_value));
    },
    hoverHandler(isHovered){
        this.buttonHover = isHovered;
    }
  },

  computed: {
    username() {
      return this.$store.state.user.username;
    },
  },

  mounted() {
    if (!this.$store.state.user) {
      this.$router.push("/about");
    }

    //set dates initialization
    this.mapCenter = this.upcCenter; //start at UPC

    this.devexp = this.$store.state.devexp;

    //get all buildings
    axios.post(
      process.env.VUE_APP_API_URL + '/getAllBuildingNames', 
          { headers: { authorization: localStorage.getItem('density.token') }}
    ).then(response =>{
      
      //all buildings
      //console.log(response.data);
      this.all_buildings_name.push(...response.data);
      this.$store.commit("all_buildings_name", this.all_buildings_name);

      //generate parameters for time range
      let startTimeStamp = this.start_date.getTime()/1000;
      let endTimeStamp = this.end_date.getTime()/1000;

      // console.log("start_time:", this.start_date, startTimeStamp, "end_time:", this.end_date, endTimeStamp);

      //generate timestamp array
      this.all_day_value = [];
      let vm = this;
      for(let ts = startTimeStamp; ts <= (endTimeStamp + 3600*24); ts+= 3600){
          this.all_day_value.push(ts*1000);
      }

      // console.log(this.all_day_value);

      //request for footprint containing hourly data based on buildings and time range preference
      axios.post(
        process.env.VUE_APP_API_URL + '/getFootprintWithHourlyData', 
            {start_time: startTimeStamp, end_time: endTimeStamp, building_list:JSON.stringify(this.user_buildings)},
            { headers: { authorization: localStorage.getItem('density.token') }}
      ).then(response =>{
        
        console.log(response.data);
        //////////////////////////////////////////////////////////////////////////
        // density data, footprint, search_options
        vm.density_data = response.data.density_data;
        vm.footprint = response.data.footprint;
        vm.search_options = response.data.search_options;
        vm.top_building_density = response.data.top_building_density;
        
        //store data
        //vm.$store.commit("density_data", vm.density_data);

        //get maximum of building count by loop over the footprint
        vm.max_density_count = vm.density_data.max_count;
        vm.max_density_count = (parseInt(vm.max_density_count/100) + 1)*100;          //round to closet hundreds
        vm.thres_scale = d3.scalePow().exponent(0.4).domain([0, vm.max_density_count]).range([0, vm.max_density_count]);  //scale threshold to nonlinear

        //top 10 buildings
        this.top10_buildingChartOptions = this.plotCharts(vm.top_building_density);
        
        
        this.$nextTick(()=>{
          
          let self = this;
  
          //////////////////////////////////////////////////////////////////////////////////////////////////////////
          // Map Set up
          let map = new mapboxgl.Map({
              accessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
              container: self.$refs.mapboxglMap,
              style: process.env.VUE_APP_BASE_MAP,
              center: self.mapCenter,
              zoom: process.env.VUE_APP_ZOOM_LEVEL,
          });

          this.map = map;

          map.on("load", () => {

            map.addSource("footprints", {
              type: "geojson",
              data: this.footprint,
              promoteId: "id"
            });

            //set intial feature state
            this.initMapFeatureStates();

            //add footprints layer
            map.addLayer({
              id: "footprints",
              type: "fill",
              source: "footprints",
              paint: { 
                  "fill-color": [ "interpolate", ["linear"], ["feature-state", "count"], 0, "#ffcf33", this.max_density_count, "#e50000"],
                  "fill-opacity": ["case", ["boolean", ["feature-state", "hover"], false], 0.3, 1.0 ],
              },
            });

            //add footprints layer
            map.addLayer({
              id: "footprints-disable",
              type: "fill",
              source: "footprints",
              paint: { 
                "fill-color": "#9da1a6",
                "fill-opacity": ["case", ["boolean", ["feature-state", "disabled"], false], 1.0, 0.0 ],
              },
            });

            //top-10 red border
            map.addLayer({
              id: 'footprints-top10',
              type: 'line',
              source: "footprints",
              paint: {
                'line-color': ["case", ["boolean", ["feature-state", "top10_border"], false], "#ff0000", "#ffffff"],
                'line-width': 2
              }
            });

            //add footprint border line layer
            map.addLayer({
              id: 'footprints-outline',
              type: 'line',
              source: "footprints",
              paint: {
                'line-color': ["case", ["boolean", ["feature-state", "border"], false], "#009200", "#ffffff"],
                'line-width': 2,
                'line-opacity': ["case", ["boolean", ["feature-state", "border"], false], 1, 0]
              }
            });  

            //add footprints names layer
            map.addLayer({
              id: "footprints-names",
              type: "symbol",
              source: "footprints",
              layout: { 
                "text-field": ["get", "name"],
                "text-variable-anchor": ["center"],
                "text-radial-offset": 0,
                "text-justify": "auto"
              },
              paint: { "text-color": "#0000ff" },
            });

            map.on('click', 'footprints', function(e) {
                  
              // var bbox = [ [e.point.x - 5, e.point.y - 5], [e.point.x + 5, e.point.y + 5] ];  // 5px around clicked point
              // var features = map.queryRenderedFeatures(bbox, { layers: ['footprints'] });
              this.building_name = e.features[0].properties.name;
              this.building_id = e.features[0].id;
                  
              //set border feature state
              var border_state = map.getFeatureState({source:"footprints", id:this.building_id}).border;
              map.setFeatureState({ source: "footprints", id: this.building_id }, { border: !border_state});

              //add building to selected stack when they selected and remove when it is unselected
              if(border_state == false){
                    
                //set selected building to be shown
                // this.building_name = e.features[0].properties.name;
                axios.post(
                  process.env.VUE_APP_API_URL + '/getHourlyDataForOneBuilding', 
                  {start_time:this.start_date.getTime()/1000, end_time: this.end_date.getTime()/1000, building_name:e.features[0].properties.name},
                  { headers: { authorization: localStorage.getItem('density.token') }}
                ).then(response =>{

                  let building_footprint = response.data;
                  //console.log(building_footprint);

                  //if can find
                  if(building_footprint != null){
                    this.addBuildingToStack(building_footprint);                    
                  }

                  //console.log(this.building_selected);

                  //plot
                  this.selected_buildingChartOptions = this.plotCharts(this.building_selected);

                });


                //draw the plot
                //this.$store.commit("building", this.building);

              }else{
                    
                //remove data from stack
                this.removeBuildingFromStack(this.building_id);
                    
                //reset id, name, ... of shown building
                if(this.building_selected.length == 0){
                  this.building = null;
                }

                this.selected_buildingChartOptions = this.plotCharts(this.building_selected);

              }
                  
            }.bind(this));  //must bind this!

            //change cursor over footprint layer.
            map.on("mouseenter", "footprints", function() {
              map.getCanvas().style.cursor = "pointer";
            });

            map.on("mouseleave", "footprints", function() {
              map.getCanvas().style.cursor = "";
            });

            //update feature state for the feature under the mouse.
            var hoveredStateId = null;
            map.on("mousemove", "footprints", function(e) {
              if (e.features.length > 0) {
                //set hover effects to false if mouse is not inside the footprints
                if (hoveredStateId) {
                  map.setFeatureState({ source: "footprints", id: hoveredStateId }, { hover: false });
                }

                //set hover effects to true if mouse is inside the footprints and set hoverstateId to building id
                hoveredStateId = e.features[0].id;
                map.setFeatureState({ source: "footprints", id: hoveredStateId }, { hover: true });
              }
            });

            //update the feature state of the previously hovered feature.
            map.on("mouseleave", "footprints", function() {
              //set hover effect to false only if mouse is leave the footprint
              if (hoveredStateId) {
                map.setFeatureState({ source: "footprints", id: hoveredStateId }, { hover: false });
              }
              hoveredStateId = null;
            });

          });
          //END map.on

        });
        //END request
      
      });
      //END next ticks
  });
  //END all buildings name request
  }
};
</script>
<style>
main {
  margin-bottom: 4.5rem;
  margin-top: 65px;
  text-align: left;
}

h1,
h2,
h3 {
  color: #990000;
}

.navbar.navbar-dark.bg-dark {
  background-color: #990000 !important;
}

.map-container {
  width: 100%;
  height: 515px;
}

.building-container {
  position:relative;
}

.building-overlay {
  position: absolute;
  top:0px;
  left:0px;
  padding: 0px;
  z-index: 1;
}

.building-overlay .building-overlay-inner {
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  padding: 0px;
  margin-bottom: 0px;
}

.map-overlay-nav-campus-btn {
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  padding: 10px;
  display: inline-block; 
}

.map-overlay-nav-search-bar {
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  padding: 8px;
  display: inline-block;
  width:500px;
}

.map-overlay-nav-date-range {
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  padding: 8px;
  display: inline-block;
}

.map-overlay {
  font: 12px/20px "Helvetica Neue", Arial, Helvetica, sans-serif;
  position: absolute;
  top: 25px;
  right: 25px;
  padding: 5px;
}

.map-overlay .map-overlay-inner {
  background-color:rgba(255,255,255,0.9);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  padding: 5px;
  padding-left: 10px;
  padding-right:10px;
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
        display: none;
}

#myinput {
  height: 12px;
  width: 250px;
  -webkit-appearance: none;
  background: linear-gradient(to right, #fca107, #e50000);
  outline: none;
  display: block;
}

input[type='range']::-webkit-slider-thumb {
  width: 6px;
  -webkit-appearance: none;
  height: 15px;
  background:black;
  border-radius: 2px;
}

#mypopup {
  width: 100px;
  padding: 20px;
  font-family: Arial, sans-serif;
  font-size: 10pt;
  background-color: white;
  border-radius: 6px;
  z-index:100;
}

dt, dd
{
  display: inline;
}   

</style>
